document.addEventListener('DOMContentLoaded', () => {
  const checkProgressBar = () => {
    const progressBar = document.getElementById('progress-container');
    if (progressBar) {
      if (window.Shopify.locale === 'en') {
        progressBar.classList.add('hidden');
      } else {
        progressBar.classList.remove('hidden');

        translations.nl = {
          addMore: 'Besteed nog {amount} voor gratis verzending',
          congratulations: 'De verzendkosten zijn gratis!',
        };
        translations.de = {
          addMore: 'Nur noch {amount} € bis zum kostenlosen Versand!',
          congratulations: 'Der Versand ist kostenlos!',
        };
      }
      clearInterval(intervalId); // Stop checking once the progress bar is found
    }
  };

  // Check for the progress bar every 500 milliseconds
  const intervalId = setInterval(checkProgressBar, 500);
});
